<template>
  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    disabled
    scrollable
  >
    <v-card class="pa-5">
      <v-card-title class="justify-center text-h4 font-weight-bold">
        {{ cdTitle }}
      </v-card-title>
      <v-card-text v-if="plan == 'Pro'">
        <v-sheet class="pa-5 pt-0">
          <v-switch
            v-model="subscriptionPeriod"
            inset
            false-value="monthly"
            true-value="yearly"
            class="subscription-period-switch pa-0 mx-auto mt-4" 
            hide-details
            data-testid="subscription-period-switch"
            :ripple="false"
          >
            <template #prepend>
              <p class="small my-1 mr-3" :class="{'accent--text': subscriptionPeriod == 'monthly', 'greytext--text': subscriptionPeriod == 'yearly'}">{{ $t('monthly') }}</p>
            </template>
            <template #append>
              <p class="small my-1" :class="{'accent--text': subscriptionPeriod == 'yearly', 'greytext--text': subscriptionPeriod == 'monthly'}">{{ $t('yearly') }}</p>
            </template>
          </v-switch>
        </v-sheet>
        <v-card
          rounded="xxl"
          max-width="400px"
          class="mx-auto pa-5"
          :img="imgUpgradeToPro"
        >
          <v-card-text
            class="white--text pa-0"
            v-if="subscriptionPeriod == 'yearly'"
          >
            <v-row no-gutters>
              <v-col cols="12">
                <p class="d-inline-block float-right">
                  <v-chip
                    class="d-flex"
                    label
                    color="darktext"
                    text-color="white"
                    small
                    >{{ $t('upgradeToProSaveYearlyPercentage', { value: '13%'}) }}
                  </v-chip>
                </p>
                <p class="font-weight-bold">Pro {{ $t("plan") }}</p>
                <p class="font-weight-bold">
                  <span class="text-h4">€816</span>
                  <span class="text-lowercase">/{{ $t('yearly') }}</span>
                </p>
                <p>{{ $t('upgradeToProSaveYearlyAmount', { value: '€120'}) }}</p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text class="white--text pa-0" v-else>
            <v-row no-gutters>
              <v-col cols="12">
                <p class="font-weight-bold">Pro {{ $t("plan") }}</p>
                <p class="font-weight-bold">
                  <span class="text-h4">€78</span>
                  <span class="text-lowercase">/{{ $t('monthly') }}</span>
                </p>
                <p></p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-0 justify-center">
            <v-btn
              width="200px"
              class="text-none text-h6 font-weight-bold"
              @click="upgradeToProPlan()"
              data-testid="upgrade-to-pro-button"
              :loading="loading"
              >{{ $t("upgrade") }}</v-btn
            >
          </v-card-actions>
        </v-card>
        <div style="width: fit-content" class="mx-auto mt-6 darktext--text">
          <p class="mb-6">{{ $t('upgradeToProDescriptionTitle') }}</p>
          <p class="mb-1">
            <v-icon class="mr-2">mdi-check-bold</v-icon>
            {{ $t('upgradeToProDescriptionIncludedFeatureBoosters') }}
          </p>
          <p class="mb-1">
            <v-icon class="mr-2">mdi-check-bold</v-icon>
            {{ $t('upgradeToProDescriptionIncludedFeaturesSpaceMembers') }}
          </p>
          <p>
            <v-icon class="mr-2">mdi-check-bold</v-icon>
            {{ $t('upgradeToProDescriptionIncludedFeaturesGuests') }}
          </p>
          <p>
            <a
              class="greytext--text text-caption"
              target="_blank"
              href="https://skillboost.io/pricing-page/"
            >
              {{ $t('upgradeToProSeeAllFeaturesLink') }}
            </a>
          </p>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { checkoutProMonthly, checkoutProYearly } from "../api/spaceApi";

export default {
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: "",
    },
    plan: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      spaceId: window.$cookies.get("space_id"),
      subscriptionPeriod: "monthly",
      loading: false,
      imgUpgradeToPro: require('@/assets/upgrade-plan-bg.png')
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  async created() {},

  methods: {
    async upgradeToProPlan() {
      this.loading = true
      if (this.subscriptionPeriod == "monthly") {
        try {
          const response = await checkoutProMonthly(this.spaceId);
          if (response.status) {
            if (response.status == 200) {
              window.location.href = response.data.meta.stripe_session_url
            }
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 403) {
              this.$router.push({ name: "PageAccessDenied" });
            } else {
              this.$emit('proceedError')
            }
          }
        }
      } else {
        try {
          const response = await checkoutProYearly(this.spaceId);
          if (response.status) {
            if (response.status == 200) {
              window.location.href = response.data.meta.stripe_session_url
            }
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 403) {
              this.$router.push({ name: "PageAccessDenied" });
            } else {
              this.$emit('proceedError')
            }
          }
        }
      }
      this.loading = false
    },
  },
};
</script>